import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { urler } from '../../router/router-urler';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.BygningLekkasjeOgVannskaderLekkasjeFraRorIBoligen,
        tekst: 'Lekkasje fra rør innendørs',
        undertekst: 'Lekkasje fra rør, hvitevarer eller varmtvannsbereder',
    },
    {
        id: KategoriSvarId.BygningLekkasjeOgVannskaderLekkasjeFraRorPaTomten,
        tekst: 'Lekkasje fra rør på tomten min',
        undertekst: 'Unaturlig vannoppsamling på tomten',
    },
    {
        id: KategoriSvarId.BygningLekkasjeOgVannskaderTilbakeslag,
        tekst: 'Tilbakeslag',
        undertekst: 'Vann eller kloakk som kommer opp fra sluk, do eller vask',
    },
    {
        id: KategoriSvarId.BygningLekkasjeOgVannskaderVannskadeFraHustakEllerYttervegg,
        tekst: 'Vannskade fra hustak eller yttervegg',
        undertekst: 'Vann utenfor hus eller hytte, har kommet inn i loft eller rom',
    },
    {
        id: KategoriSvarId.BygningLekkasjeOgVannskaderVvannskadeIKjeller,
        tekst: 'Vannskade i kjeller',
        undertekst: 'Vann har kommet inn i kjelleren',
    },
    {
        id: KategoriSvarId.BygningLekkasjeOgVannskaderAnnenVannskade,
        tekst: 'Annen vannskade',
    },
];

export const BygningLekkasjerOgVannskader = () => {
    const navigate = useNavigate();
    const onNext = (svarId: KategoriSvarId) => {
        if (svarId === KategoriSvarId.BygningLekkasjeOgVannskaderLekkasjeFraRorIBoligen) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningVannskadeLekkasjeInne));
        } else if (svarId === KategoriSvarId.BygningLekkasjeOgVannskaderLekkasjeFraRorPaTomten) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningVannskadeLekkasjeUtvendigRor));
        } else if (svarId === KategoriSvarId.BygningLekkasjeOgVannskaderTilbakeslag) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningVannskadeTilbakeslag));
        } else if (svarId === KategoriSvarId.BygningLekkasjeOgVannskaderVannskadeFraHustakEllerYttervegg) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningVannskadeHustakYttervegg));
        } else if (svarId === KategoriSvarId.BygningLekkasjeOgVannskaderVvannskadeIKjeller) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningVannskadeKjeller));
        } else if (svarId === KategoriSvarId.BygningLekkasjeOgVannskaderAnnenVannskade) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningVannskadeAnnet));
        }
    };
    const goback = () => navigate(urler().husOgHytteUrl);
    return (
        <GruppeLandingsside
            title="Lekkasjer og vannskader"
            onNext={onNext}
            navigateToParent={goback}
            alternativer={alternativer}
            svgCardType={SvgCardType.HusEnkelt}
            radioButtonsLabel="Hva har skjedd?"
            kategoriId="bygning-lekkasjer-vannskader"
        />
    );
};
